export default __webpack_public_path__ + "static/media/chandigarh.33db76d0.png";